import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { useState } from "react";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";
import { DATA_TABLE_TOOLTIP_ID } from "../DataTableTooltip";
import { ButtonIconPlainPermissioned } from "pages/gdt/plain/ButtonIconPlain";

interface QuickActionCopyRowBaseProps {
  tableId: string;
  rowIds: string[];
  tooltipContent: string;
  isDisabled: boolean;
  deselectAll: (() => void) | undefined;
  id: string;
}

const QuickActionCopyRowBase = ({
  tableId,
  rowIds,
  deselectAll,
  tooltipContent,
  isDisabled,
  id,
}: QuickActionCopyRowBaseProps) => {
  const copyRows = useDataTableContext((s) => s.copyAnalysisTableRows);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    const { error } = await copyRows({ tableId, rowIds });
    setIsLoading(false);
    if (error === undefined) {
      deselectAll?.();
      addUtilityToastSuccess("Row(s) copied");
    } else {
      addUtilityToastFailure("Failed to copy row(s)");
    }
  };

  return (
    <ButtonIconPlainPermissioned
      requiredPermission="edit"
      aria-label={tooltipContent}
      data-tooltip-id={DATA_TABLE_TOOLTIP_ID}
      data-tooltip-content={tooltipContent}
      color="primary"
      iconSize="m"
      iconType="copy"
      onClick={() => void handleClick()}
      disabled={isDisabled}
      isLoading={isLoading}
      id={id}
    />
  );
};

interface QuickActionCopyRowProps {
  tableId: string;
  rowId: string;
  readOnly?: boolean;
}

export const QuickActionCopyRow = ({
  tableId,
  rowId,
  readOnly,
}: QuickActionCopyRowProps) => {
  return (
    <QuickActionCopyRowBase
      tooltipContent="Copy row"
      tableId={tableId}
      rowIds={[rowId]}
      deselectAll={undefined}
      isDisabled={readOnly ?? false}
      id={"quickActionCopyRow"}
    />
  );
};
export interface QuickActionCopySelectedRowsProps {
  selectedRowIds: string[];
  deselectAll: () => void;
  tableId: string;
}
export const QuickActionCopySelectedRows = ({
  selectedRowIds,
  deselectAll,
  tableId,
}: QuickActionCopySelectedRowsProps) => {
  return (
    <QuickActionCopyRowBase
      tooltipContent="Copy selected rows"
      tableId={tableId}
      rowIds={selectedRowIds}
      deselectAll={deselectAll}
      isDisabled={selectedRowIds.length === 0}
      id={"quickActionCopySelectedRows"}
    />
  );
};
